module.exports = __webpack_public_path__ + "assets/img/_Novo Show Unit_Kitchen_RGB_lr.4a22e254.jpg";